import type { Customers } from './model'
import { ActionType } from './model'

import createReducer from '../createReducer'
import { Action, Nullable } from '../model'

export interface ICustomersReducer {
  customers: Customers | null
}

const defaultState: ICustomersReducer = {
  customers: null,
}

export const customersReducer = createReducer<ICustomersReducer>(defaultState, {
  [ActionType.SET_CUSTOMERS]: (state: Nullable<ICustomersReducer>, action: Action<Nullable<Customers>>) => ({
    ...state,
    customers: action.payload,
  }),
})
